export class ListItem {
    id!: string;
    label!: string;
    isDisabled?: boolean;
    unselectable?: boolean;

    public constructor(source: any) {
        if (typeof source === 'string' || typeof source === 'number') {
            this.id = this.label = source.toString();
            this.isDisabled = false;
            this.unselectable = false;
        }
        if (typeof source === 'object') {
            this.id = source.id;
            this.label = source.label;
            this.isDisabled = source.isDisabled;
            this.unselectable = source.unselectable;
        }
    }
}
